import React from 'react';
import { cn } from '@/lib/utils';
import { useLocation } from 'react-router-dom';
// No longer need icon imports
import ChatInput from './ChatInput';
import { useChatInterface } from '@/contexts/ChatInterfaceContext';

interface WelcomeScreenProps {
  onSubmit?: (content: string) => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onSubmit }) => {
  const { currentPosit } = useChatInterface();
  const location = useLocation();
  
  // Detect context based on route
  const isUpdateContext = location.pathname.includes('/update-posit') || location.pathname.includes('/create-posit');
  
  // Generate the main message based on context
  const getMainMessage = () => {
    if (!currentPosit) {
      return "Your intelligent assistant powered by your personal knowledge base.";
    }
    
    if (isUpdateContext) {
      return `Add knowledge to your Posit.`;
    } else {
      // Chat context - don't show title here (will be shown above pills)
      return null;
    }
  };

  return (
    <div className="flex-1 flex flex-col items-center justify-center min-h-0 px-4 py-4">
      <div className="w-full max-w-4xl mx-auto space-y-6">
        {/* Header */}
        {getMainMessage() && (
          <div className="text-center space-y-4">
            <div className="space-y-2">
              {/* Show posit title in update context, similar to chat context */}
              {isUpdateContext && currentPosit?.title && (
                <h1 className="text-2xl font-semibold text-foreground mb-2">
                  {currentPosit.title}
                </h1>
              )}
              <p className="text-lg text-muted-foreground max-w-lg mx-auto">
                {getMainMessage()}
              </p>
            </div>
          </div>
        )}

        {/* Chat Input */}
        <div className="space-y-4">
          <ChatInput 
            variant="welcome"
            placeholder={
              currentPosit 
                ? isUpdateContext
                  ? "What would you like to add?"
                  : "Ask anything"
                : "How can I help you today?"
            }
            onSubmit={onSubmit}
            showPositSelector={!!currentPosit}
          />
        </div>



        {/* No Posit Selected State */}
        {!currentPosit && (
          <div className="text-center space-y-3">
            <div className="p-4 bg-muted/30 rounded-xl border border-dashed border-border">
              <p className="text-sm text-muted-foreground mb-2">
                To get started, select a Posit from the sidebar or create a new one.
              </p>
              <div className="flex flex-wrap gap-2 justify-center">
                <button className="px-3 py-1 text-xs bg-primary/10 text-primary rounded-full hover:bg-primary/20 transition-colors">
                  Sign Up
                </button>
                <button className="px-3 py-1 text-xs bg-muted text-muted-foreground rounded-full hover:bg-muted/80 transition-colors">
                  Create Posit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WelcomeScreen; 